import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import Glide from "@glidejs/glide";

//IMPORTANT: need to remove the "dist" from the path
import "@shoelace-style/shoelace/dist/components/drawer/drawer.js";

import "@shoelace-style/shoelace/dist/components/progress-bar/progress-bar.js";
import "@shoelace-style/shoelace/dist/components/tooltip/tooltip.js";
import "@shoelace-style/shoelace/dist/components/rating/rating.js";
import "@shoelace-style/shoelace/dist/components/alert/alert.js";
import "@shoelace-style/shoelace/dist/components/dialog/dialog.js";
import "@shoelace-style/shoelace/dist/components/select/select.js";
import "@shoelace-style/shoelace/dist/components/option/option.js";
import "@shoelace-style/shoelace/dist/components/input/input.js";
import "@shoelace-style/shoelace/dist/components/spinner/spinner.js";
import "@shoelace-style/shoelace/dist/components/alert/alert.js";
import "@shoelace-style/shoelace/dist/components/include/include.js";
import "@shoelace-style/shoelace/dist/components/details/details.js";
import React from "react";

// vendor libs
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
Alpine.plugin(collapse);
import * as cart from "@shopify/theme-cart";
import { stripHtml } from "string-strip-html";

// all fusion core
import { pdpCore } from "./framework/fusion-pdp/pdp-core";
import { modalCore } from "./utils/modalCore";
import {
  initFusionPdpSlider,
  handleVpChange,
} from "./framework/fusion-pdp/pdp-slider";
import { fusionReveal } from "./utils/animations";

import "../../assets/visual-filters.js";
import "../../assets/sticky-header.js";

import { initInfluencerStorefront } from "./framework/fusion-inf/inf-main";

document.addEventListener("DOMContentLoaded", () => {
  const clearSortFilter = () => {
    // document.getElementById('sidebar-clear-button').addEventListener('click',
    // function() { Get the current URL
    let url = new URL(window.location.href);
    console.log(url);
    let searchParams = url.search
      .split("&")
      .filter((param) => param.includes("page"));
    console.log(searchParams);

    url.search = "";
    // Remove specific parameters
    url.searchParams.delete("filter.v.option.size");
    url.searchParams.delete("filter.v.availability");

    // Add the desired parameter
    url.searchParams.set("filter.v.availability", "1");

    // Optionally, set the page parameter
    url.searchParams.set("page", searchParams[0] || "1"); // Change '1' to the desired page number

    // Redirect to the new URL
    window.location.href = url.toString();
    // });
  };

  const pdpDescriptionElement = document.querySelector(
    ".pdp-inner-description",
  );
  if (pdpDescriptionElement) {
    let spawn = pdpDescriptionElement.innerHTML;
    let stripped = stripHtml(spawn).result;

    // Define a regular expression to match the sections
    const regex =
      /(Features:|Description:|Details:)([\s\S]*?)(?=(Features:|Description:|Details:|$))/g;

    let respawned = "";
    let match;

    // Iterate over each match and wrap it in a div with a class
    while ((match = regex.exec(stripped)) !== null) {
      const sectionTitle = match[1].toLowerCase().replace(":", ""); // e.g., "features"
      const sectionContent = match[2].trim(); // Content after the title

      if (sectionContent) {
        // Split the section content by new lines and wrap each line in a <p>
        // tag
        const formattedContent = sectionContent
          .split("\n")
          .filter((line) => line.trim() !== "") // Filter out empty lines
          .map((line) => `<p>${line}</p>`)
          .join("");

        respawned += `<div class="${sectionTitle} mb-6"><p class="text-black font-semibold">${match[1]}</p>${formattedContent}</div>`;
      }
    }

    pdpDescriptionElement.innerHTML = respawned;
  }

  console.log("Fusion Framework Loaded");
  // !important don't fux with this
  const currentTemplate = document.getElementById("FusionFrameworkInit");

  // ! Important: all elements that need to be intereacted in the DOM need to go
  // here register DOM elements for use
  window.fusionElements = {
    drawer: document.querySelector(".fusion-cart__drawer"),
    cartError: document.getElementById("fusionCartAlert"),
    modal: document.getElementById("fusionModalMain"),
    mobileQuickShopDrawer: document.getElementById("fusionQuickShopDrawer"),
    showQuickShopDrawer: false,
    showUpsell: false,
    clearSortFilter: clearSortFilter,
  };

  let initUpsellDisplay = localStorage.getItem("showUpsell");
  if (initUpsellDisplay) {
    window.fusionElements.showUpsell = JSON.parse(initUpsellDisplay);
  }

  const getActiveVariantById = (variantId) => {
    if (!variantId) return null;

    return Alpine.store("activeProduct")?.activeProduct?.variants?.find(
      (variant) => variant.id == Number(variantId),
    );
  };

  const getCartQuantityForVariant = (variantId) => {
    if (!variantId) return 0;

    return (Alpine.store("cart")?.cartItems || []).reduce((total, item) => {
      if (item.id == variantId || item.variant_id == variantId) {
        return total + item.quantity;
      }

      return total;
    }, 0);
  };

  const isLimitedInventoryVariant = (variant) => {
    return (
      variant?.inventory_management === "shopify" &&
      variant?.inventory_policy !== "continue"
    );
  };

  const canAddVariantToCart = (variant) => {
    if (!variant?.id || variant.available === false) {
      return false;
    }

    if (!isLimitedInventoryVariant(variant)) {
      return true;
    }

    const inventoryQuantity = Number(variant.inventory_quantity);
    if (!Number.isFinite(inventoryQuantity)) {
      return true;
    }

    return getCartQuantityForVariant(variant.id) < inventoryQuantity;
  };

  const refreshSelectedVariantCartAvailability = () => {
    Alpine.store("selectedVariant")?.refreshCanAddToCart?.();
  };

  const buildSelectedVariantStore = (initialState) => ({
    id: initialState.id || "",
    title: initialState.title || "Select A Size",
    displayAtc:
      typeof initialState.displayAtc === "boolean"
        ? initialState.displayAtc
        : initialState.id !== "",
    available: initialState.available || false,
    inventory_quantity: initialState.inventory_quantity,
    inventory_management: initialState.inventory_management,
    inventory_policy: initialState.inventory_policy,
    canAddToCart: canAddVariantToCart(initialState),
    updateActiveVariant(data) {
      const variant = getActiveVariantById(data.id);
      const nextVariant = {
        ...variant,
        ...data,
      };

      this.id = nextVariant.id || "";
      this.title = nextVariant.title || "";
      this.displayAtc =
        typeof nextVariant.displayAtc === "boolean"
          ? nextVariant.displayAtc
          : nextVariant.id !== "";
      this.available =
        typeof nextVariant.available === "boolean"
          ? nextVariant.available
          : false;
      this.inventory_quantity = nextVariant.inventory_quantity;
      this.inventory_management = nextVariant.inventory_management;
      this.inventory_policy = nextVariant.inventory_policy;
      this.refreshCanAddToCart();
    },
    refreshCanAddToCart() {
      const variant = getActiveVariantById(this.id) || this;
      this.canAddToCart = canAddVariantToCart({
        ...variant,
        id: this.id,
        available: this.available,
        inventory_quantity: this.inventory_quantity,
        inventory_management: this.inventory_management,
        inventory_policy: this.inventory_policy,
      });
    },
    markUnavailableInCart() {
      this.canAddToCart = false;
    },
  });

  Alpine.store("cart", {
    recs: {
      product_id: window.theme.fusion_recs.product_id,
    },
    cartData: {},
    cartItems: [],
    cartCount: 0,
    cartError: {
      id: "",
      message: "",
    },
    updateCartState(newCartData) {
      this.cartData = newCartData;
      this.cartItems = newCartData.items;
      this.cartCount = newCartData.item_count;
      refreshSelectedVariantCartAvailability();
    },
    updateCartError(id, message) {
      this.cartError = {
        id: id,
        message: message,
      };
    },
  });

  // set init cart state
  cart.getState().then((cartState) => {
    fetch("/cart?view=json")
      .then((response) => response.json())
      .then((data) => {
        let newCartData = JSON.parse(data);
        cartState.total_savings = 0; // Initialize total savings to zero
        cartState.items.forEach((item) => {
          const variantToUpdate = newCartData.find((o) => o.id === item.id);
          if (
            variantToUpdate &&
            variantToUpdate.compare_at_price !== undefined
          ) {
            item.compare_at_price = variantToUpdate.compare_at_price;
            item.is_on_sale = true;
            const savings =
              (item.compare_at_price - item.price) * item.quantity;
            cartState.total_savings += savings;
          } else {
            item.compare_at_price = null;
            item.is_on_sale = false;
          }
        });
        Alpine.store("cart").updateCartState(cartState);
      })
      .catch((error) => console.error("Error fetching JSON:", error));
  });

  Alpine.store("fusionQuickShop", {
    productObject: "",
    updateProductObject(data) {
      this.productObject = data;
    },
  });

  localStorage.getItem("INF_STATUS");
  let currentInfStatus = localStorage.getItem("INF_STATUS");
  if (currentInfStatus == "true") {
    let rawINF = JSON.parse(localStorage.getItem("INF_SELECTION"));

    Alpine.store("infSelector", {
      isActive: true,
      activeList: {
        listName: rawINF.listName,
        listHandle: rawINF.listHandle,
        listProducts: rawINF.listProducts,
        listProductsJson: rawINF.listProductsJson,
        metaObjectGID: rawINF.metaObjectGID,
        listId: rawINF.listId,
        createdAt: rawINF.createdAt,
        updatedAt: rawINF.updatedAt,
      },
      addProduct(eventData) {
        console.log(eventData);
        const productObject = JSON.parse(eventData.detail);

        // Check if the product already exists based on ID
        const productExists = this.activeList.listProductsJson?.some(
          (product) => product.id === productObject.id,
        );

        if (!productExists) {
          console.log("Adding product:", productObject);
          this.activeList.listProductsJson?.unshift({
            title: productObject.title,
            handle: productObject.handle,
            imageUrl: productObject.imgUrl,
            id: productObject.id,
          });

          this.activeList.listProducts.unshift(productObject.handle);

          localStorage.setItem(
            "INF_SELECTION",
            JSON.stringify(Alpine.raw(Alpine.store("infSelector").activeList)),
          );

          console.log("active", Alpine.raw(Alpine.store("infSelector")));
          // Get the element and trigger the animation
          let yeet = document.getElementById("infSelectSuccessPop");
          if (yeet) {
            yeet.style.transform = "translate-y(-33px)";
            console.log(yeet);

            // Add the animation class
            yeet.style.animation = "slideUpDown 2.5s ease-in-out forwards";

            // Remove the active class and animation after the animation is
            // complete
            setTimeout(() => {
              yeet.classList.remove("infSelectSuccessPopActive");
              yeet.style.animation = ""; // Reset the animation
            }, 2500); // Match this timing with the animation duration
          }
        } else {
          console.log("Product already exists:", productObject);
        }
      },
      removeProduct(eventData) {
        let rawJson = Alpine.raw(this.activeList.listProductsJson);
        let filterJson = rawJson.filter(
          (o) => o.handle !== eventData.detail.handle,
        );

        let rawHandles = Alpine.raw(this.activeList.listProducts);
        let filterHandles = rawHandles.filter(
          (o) => o !== eventData.detail.handle,
        );

        this.activeList.listProductsJson = filterJson;
        this.activeList.listProducts = filterHandles;

        localStorage.setItem(
          "INF_SELECTION",
          JSON.stringify(Alpine.raw(Alpine.store("infSelector").activeList)),
        );
      },
    });
  } else {
    Alpine.store("infSelector", {
      isActive: false,
      activeList: {},
      addProduct(eventData) {
        console.log(eventData);
        let productObject = eventData.detail;
        this.activeList.listProducts.push(productObject.handle);
        this.activeList.listProductsJson.push({
          title: productObject.title,
          handle: productObject.handle,
          imageUrl: `${productObject.images[0]}&width=50`,
          id: productObject.id,
        });
      },
    });
  }

  // Register vcolor Alpine component for PDP color swatches
  Alpine.data("vcolorData", () => ({
    coreColorsList: [],
    activeTooltipTimeout: null,
    init() {
      const data = this.$el.dataset.coreColors;
      try {
        this.coreColorsList = JSON.parse(data) || [];
      } catch (e) {
        this.coreColorsList = [];
      }
    },
    getColorName(title) {
      if (!title) return "";
      const parts = title.split("-");
      return parts[parts.length - 1].trim();
    },
    isCore(colorName) {
      if (!this.coreColorsList || this.coreColorsList.length === 0)
        return false;
      const colorLower = colorName.toLowerCase();
      return this.coreColorsList.some(
        (core) => core.trim().toLowerCase() === colorLower,
      );
    },
    getCurrentColorName() {
      return this.getColorName(this.$store.activeProduct?.activeProduct?.title);
    },
    getCurrentIsCore() {
      return this.isCore(this.getCurrentColorName());
    },
    handleSwatchClick(event, tooltipElement) {
      if (window.innerWidth <= 990) {
        if (this.activeTooltipTimeout) {
          clearTimeout(this.activeTooltipTimeout);
        }

        tooltipElement.show();

        this.activeTooltipTimeout = setTimeout(() => {
          setTimeout(() => {
            tooltipElement.hide();
          }, 300);
          this.activeTooltipTimeout = null;
        }, 3000);
      }
    },
    showTooltip(tooltipElement) {
      if (window.innerWidth > 990) {
        tooltipElement.show();
      }
    },
    hideTooltip(tooltipElement) {
      if (window.innerWidth > 990) {
        tooltipElement.hide();
      }
    },
  }));

  Alpine.data("pdpVariantSelector", () => ({
    get product() {
      return this.$store.activeProduct?.activeProduct || {};
    },
    get variants() {
      return this.product.variants || [];
    },
    get optionTitles() {
      return this.product.product_option_titles || [];
    },
    get isSingleOption() {
      return this.optionTitles.length === 1 && this.variants.length > 1;
    },
    get isMultiOption() {
      return this.optionTitles.length > 1 && this.variants.length > 1;
    },
    get isWideProduct() {
      const title = this.product.title?.toLowerCase() || "";
      return this.product.type === "scrunchie" || title.includes("scrunchie");
    },
    get showSizeGuide() {
      return (
        this.product.type !== "gift-card" && this.optionHandle(0) === "size"
      );
    },
    get showBisTrigger() {
      return (
        this.product.type !== "gift-card" &&
        this.$store.selectedVariant?.id &&
        !this.$store.selectedVariant?.available
      );
    },
    optionHandle(index) {
      return this.optionTitles[index] || `option-${index + 1}`;
    },
    optionLabel(index) {
      return (
        this.product.product_option_labels?.[index] ||
        this.optionHandle(index).replaceAll("-", " ")
      );
    },
    optionValues(position) {
      const valueKey = `option${position}`;
      const labelKey = `${valueKey}_label`;
      const seen = new Set();

      return this.variants.reduce((options, variant) => {
        const value = variant[valueKey];
        if (!value || seen.has(value)) return options;

        seen.add(value);
        options.push({
          value,
          label: variant[labelKey] || value.replaceAll("-", " "),
        });

        return options;
      }, []);
    },
    singleOptionVariantLabel(variant) {
      return variant.option1_label || variant.title?.replace(" / ", " ") || "";
    },
  }));

  switch (currentTemplate.dataset.fusiontemplate) {
    case "product":
      // Init all product page related data
      Alpine.store("activeProduct", {
        activeSlide: 0,
        totalSlides: window.fusionDataLayer.activeProduct.images.length,
        activeProduct: window.fusionDataLayer.activeProduct,
        setActiveSlide(index) {
          this.activeSlide = index;
        },
        updateActiveProduct(data) {
          this.activeProduct = data;
          this.totalSlides = data.images.length;
          this.activeSlide = 0;
        },
        nextSlide() {
          this.activeSlide++;
          if (this.activeSlide >= this.totalSlides) {
            this.activeSlide = 0;
          }

          this.scrollToActiveThumbnail(this.activeSlide);
        },
        prevSlide() {
          this.activeSlide--;
          if (this.activeSlide < 0) {
            this.activeSlide = this.totalSlides - 1;
          }

          this.scrollToActiveThumbnail(this.activeSlide);
        },
        /**
         * Scroll to active thumbnail.
         * @param {Number} activeIndex - Active slide index
         * @returns
         */
        scrollToActiveThumbnail(activeIndex) {
          const activeThumbnail = document.querySelectorAll(
            "[fusion-pdp-thumbnail]",
          )[activeIndex];

          if (!activeThumbnail) {
            return;
          }

          activeThumbnail.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            container: "nearest",
          });
        },
      });

      if (
        window.fusionDataLayer.activeProduct.product_option_titles.length > 1
      ) {
        Alpine.store("vMultiSelect", {
          activeOptionOne: "",
          activeOptionTwo: "",
          updateActiveOptionOne(obj) {
            this.activeOptionOne = obj;
          },
          updateActiveOptionTwo(obj) {
            this.activeOptionTwo = obj;
          },
        });
      }

      // custom back in stock component
      Alpine.store("fusionBIS", {
        variantId: "",
        email: "",
        isLoading: false,
        displaySubmit: false,
        updateBisVariant(variantId) {
          this.variantId = variantId;
        },
        updateBisEmail(email) {
          this.email = email;
        },
        updateLoading(data) {
          this.isLoading = data;
        },
      });

      if (window.fusionDataLayer.activeProduct.variants.length == 1) {
        Alpine.store(
          "selectedVariant",
          buildSelectedVariantStore({
            ...window.fusionDataLayer.activeProduct.variants[0],
            title: "Select A Size",
            displayAtc: true,
          }),
        );
      } else {
        Alpine.store(
          "selectedVariant",
          buildSelectedVariantStore({
            id: "",
            title: "Select A Size",
            displayAtc: false,
            available: false,
          }),
        );
      }

      refreshSelectedVariantCartAvailability();

      // handle resize of window for PDP slider
      window.addEventListener("resize", () =>
        handleVpChange(window.innerWidth),
      );

      // Automatically init slider under 900px view port width
      if (window.innerWidth < 1001) {
        console.log("init slider", window.innerWidth);
        // window.fusionElements.drawer.setAttribute("placement", "end");
        initFusionPdpSlider();
      } else {
        window.fusionDataLayer.activeSlider = false;
        // window.fusionElements.drawer.setAttribute("placement", "end");
      }

      // Animation fade in on PDP
      fusionReveal();

      // init F U S I O N // R A C T O R
      pdpCore();
      break;
    case "collection":
      // Init all collection data

      Alpine.store(
        "selectedVariant",
        buildSelectedVariantStore({
          id: "",
          title: "Select A Size",
          displayAtc: false,
          available: false,
        }),
      );

      break;
    default:
      Alpine.store(
        "selectedVariant",
        buildSelectedVariantStore({
          id: "",
          title: "Select A Size",
          displayAtc: false,
          available: false,
        }),
      );
  }

  // !IMPORTANT keep this at the end of the file or init errors will occur
  Alpine.start();
  window.Alpine = Alpine;
  initInfluencerStorefront();
  let infSfSelectorSummary = document.getElementById("infSfSelectorSummary");
  if (infSfSelectorSummary) {
    infSfSelectorSummary.addEventListener("sl-show", (e) => {
      e.target.classList.add("selectorSummaryOpen");
    });
  }
});

// Drawer hide and remove scroll lock
document.addEventListener("sl-after-hide", (e) => {
  if (e.target.id == "fusionQuickShopDrawer") {
    document.querySelector("html").classList.remove("scroll-locked--custom");
  } else if (e.target.id == "fusionProductRecs") {
    localStorage.setItem("showUpsell", JSON.stringify(false));
    return;
  }

  document.querySelector("html").classList.remove("scroll-locked--custom");
});

// apply scroll lock on drawer and dialog and and expand for all other needs
document.addEventListener("sl-show", (e) => {
  const targetNode = e.target.nodeName;
  const isDesktopFilterDrawer = e.target.id === "filterDrawer";

  if (
    (targetNode == "SL-DRAWER" || targetNode == "SL-DIALOG") &&
    !isDesktopFilterDrawer
  ) {
    document.querySelector("html").classList.add("scroll-locked--custom");
  } else if (
    e.target.id == "fusionCartDrawer" ||
    e.target.id == "fusionProductRecs"
  ) {
    document.querySelector("html").classList.add("scroll-locked--custom");
    localStorage.setItem("showUpsell", JSON.stringify(true));
  }
});

// handle all product removal from inside the cart component
document.addEventListener("removeCartProduct", async (e) => {
  const lineItemELm = document.getElementById(e.detail.lineKey);
  const lineItemKey = e.detail.lineKey;
  lineItemELm.classList.add("fusion__content-loading");

  try {
    const cartState = await cart.removeItem(lineItemKey);
    try {
      const response = await fetch("/cart?view=json");
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      let newCartData = JSON.parse(data);

      cartState.total_savings = 0; // Initialize total savings to zero
      cartState.items.forEach((item) => {
        const variantToUpdate = newCartData.find((o) => o.id === item.id);
        if (variantToUpdate && variantToUpdate.compare_at_price !== undefined) {
          item.compare_at_price = variantToUpdate.compare_at_price;
          item.is_on_sale = true;
          const savings = (item.compare_at_price - item.price) * item.quantity;
          cartState.total_savings += savings;
        } else {
          item.compare_at_price = null;
          item.is_on_sale = false;
        }
      });

      Alpine.store("cart").updateCartState(cartState);
    } catch (fetchError) {
      console.error("Error fetching JSON:", fetchError);
      Alpine.store("cart").updateCartState(cartState);
    }
  } catch (cartError) {
    console.log("Cart Err", cartError);
    Alpine.store("cart").updateCartError(
      e.detail.lineKey,
      "Unable to perform action",
    );
  } finally {
    lineItemELm.classList.remove("fusion__content-loading");
  }
});

// handle removing a specific line item from the cart
document.addEventListener("decreaseCartQuantity", (e) => {
  const lineItemELm = document.getElementById(e.detail.lineKey);
  const lineItemKey = e.detail.lineKey;
  const lineItemQuantity = e.detail.quantity;
  lineItemELm.classList.add("fusion__content-loading");

  cart
    .updateItem(lineItemKey, { quantity: lineItemQuantity - 1 })
    .then((cartState) => {
      try {
        fetch("/cart?view=json")
          .then((response) => response.json())
          .then((data) => {
            let newCartData = JSON.parse(data);
            cartState.total_savings = 0; // Initialize total savings to zero
            cartState.items.forEach((item) => {
              const variantToUpdate = newCartData.find((o) => o.id === item.id);
              if (
                variantToUpdate &&
                variantToUpdate.compare_at_price !== undefined
              ) {
                item.compare_at_price = variantToUpdate.compare_at_price;
                item.is_on_sale = true;
                const savings =
                  (item.compare_at_price - item.price) * item.quantity;
                cartState.total_savings += savings;
              } else {
                item.compare_at_price = null;
                item.is_on_sale = false;
              }
            });
            lineItemELm.classList.remove("fusion__content-loading");

            Alpine.store("cart").updateCartState(cartState);
          })
          .catch((error) => {
            Alpine.store("cart").updateCartState(cartState);
            lineItemELm.classList.remove("fusion__content-loading");
            console.error("Error fetching JSON:", error);
          });
      } catch (error) {
        console.error("Error fetching JSON:", error);
      }
    })
    .catch((err) => {
      console.log("Cart Err", err);
      Alpine.store("cart").updateCartError(
        e.detail.lineKey,
        "Unable To Prefrom Action",
      );
      lineItemELm.classList.remove("fusion__content-loading");
    });
});

// handle all quantity increases in the cart on a specific line item
document.addEventListener("increaseCartQuantity", (e) => {
  const lineItemELm = document.getElementById(e.detail.lineKey);
  const lineItemKey = e.detail.lineKey;
  const lineItemQuantity = e.detail.quantity;
  lineItemELm.classList.add("fusion__content-loading");

  if (lineItemQuantity <= 7) {
    cart
      .updateItem(lineItemKey, { quantity: lineItemQuantity + 1 })
      .then((cartState) => {
        try {
          fetch("/cart?view=json")
            .then((response) => response.json())
            .then((data) => {
              console.log(data);
              let newCartData = JSON.parse(data);
              cartState.total_savings = 0; // Initialize total savings to zero
              cartState.items.forEach((item) => {
                const variantToUpdate = newCartData.find(
                  (o) => o.id === item.id,
                );
                if (
                  variantToUpdate &&
                  variantToUpdate.compare_at_price !== undefined
                ) {
                  item.compare_at_price = variantToUpdate.compare_at_price;
                  item.is_on_sale = true;
                  const savings =
                    (item.compare_at_price - item.price) * item.quantity;
                  cartState.total_savings += savings;
                } else {
                  item.compare_at_price = null;
                  item.is_on_sale = false;
                }
              });
              lineItemELm.classList.remove("fusion__content-loading");

              Alpine.store("cart").updateCartState(cartState);
            })
            .catch((error) => {
              Alpine.store("cart").updateCartState(cartState);
              lineItemELm.classList.remove("fusion__content-loading");
              console.error("Error fetching JSON:", error);
            });
        } catch (error) {
          console.error("Error fetching JSON:", error);
        }
      })
      .catch((err) => {
        console.log("Cart Err", err);
        Alpine.store("cart").updateCartError(
          e.detail.lineKey,
          "Unable To Prefrom Action",
        );
        lineItemELm.classList.remove("fusion__content-loading");
      });
  } else {
    Alpine.store("cart").updateCartError(
      e.detail.lineKey,
      "Maximum Quantity Reached",
    );
    lineItemELm.classList.remove("fusion__content-loading");
  }
});

// Global for all modal name needs to equal the ID of the specific modal IE:
// 'sizeGuideModal'
document.addEventListener("openFusionModal", (e) => {
  modalCore(e.detail);
});

// Drawer hide and remove scroll lock
document.addEventListener("sl-hide", (e) => {
  if (e.target.nodeName == "SL-DIALOG") {
    document
      .querySelector(".fusion-modal-wrapper--active")
      .classList.add("fusion-modal-wrapper--hidden");
  }
});

document.addEventListener("plpAtc", (event) => {
  if (!event.target.id) return;

  let tmp = event.target.getAttribute("data-product-id-v");
  let parentTest = document.querySelectorAll(`[data-product-id="${tmp}"]`);
  let finalElmGlobal = "";

  if (window.fusionElements.drawer.hasAttribute("open")) {
    if (parentTest.length) {
      parentTest.forEach((o, i) => {
        if (o.dataset.cardtype == "upsell") {
          o?.classList.add("fusion__content-loading");
          finalElmGlobal = o;
          return o;
        }
      });
    }
  } else {
    let finalElm = parentTest[0];
    finalElm?.classList.add("fusion__content-loading");
    finalElmGlobal = finalElm;
  }

  if (window.fusionElements.mobileQuickShopDrawer.hasAttribute("open")) {
    window.fusionElements.mobileQuickShopDrawer.hide();
  }

  cart.addItem(parseInt(event.target.id), { quantity: 1 }).then((item) => {
    cart.getState().then((cartState) => {
      // Update alpine cart state
      fetch("/cart?view=json")
        .then((response) => response.json())
        .then((data) => {
          let newCartData = JSON.parse(data);
          cartState.total_savings = 0; // Initialize total savings to zero
          cartState.items.forEach((item) => {
            const variantToUpdate = newCartData.find((o) => o.id === item.id);
            if (
              variantToUpdate &&
              variantToUpdate.compare_at_price !== undefined
            ) {
              item.compare_at_price = variantToUpdate.compare_at_price;
              item.is_on_sale = true;
              const savings =
                (item.compare_at_price - item.price) * item.quantity;
              cartState.total_savings += savings;
            } else {
              item.compare_at_price = null;
              item.is_on_sale = false;
            }
          });
          Alpine.store("cart").updateCartState(cartState);
          // open cart drawer on next tick to ensure data quality
          Alpine.nextTick(() => window.fusionElements.drawer.show());
          finalElmGlobal.classList.remove("fusion__content-loading");
        })
        .catch((error) => console.error("Error fetching JSON:", error));
    });
  });
});

document.addEventListener("closeBisModal", (event) => {
  let bisEmailInput = document.getElementById("fusionBisEmail");
  bisEmailInput.value = "";

  // hide modal
  window.fusionElements.modal.hide();
});

document.addEventListener("handleBIS", async () => {
  try {
    Alpine.store("fusionBIS").updateLoading(true);

    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: Alpine.store("fusionBIS").email,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${Alpine.store("fusionBIS").variantId}`,
            },
          },
        },
      },
    };

    const companyId =
      window.Shopify.shop === "buffbunnyca.myshopify.com" ? "VFmuyC" : "RpWxXa";

    const response = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2024-06-15",
        },
        body: JSON.stringify(payload),
      },
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw errorData;
    }

    // Success handling
    setTimeout(() => {
      window.fusionElements.modal.hide();
      Alpine.store("fusionBIS").updateLoading(false);
      setTimeout(() => {
        alert("Successfully Signed Up!");
      }, 300);
    }, 1600);
  } catch (error) {
    console.error("Error:", error);
    alert("Error Submitting Sign Up");
    Alpine.store("fusionBIS").updateLoading(false);
  }
});

document.addEventListener("mobileQuickShop", (e) => {
  Alpine.store("fusionQuickShop").updateProductObject(e.detail);
  window.fusionElements.showQuickShopDrawer = true;

  window.fusionElements.mobileQuickShopDrawer.show();

  if (e.detail.variants.length == 1) {
    Alpine.store("selectedVariant").updateActiveVariant({
      id: e.detail.variants[0].id,
      title: "Add To Cart",
      displayAtc: true,
      available: e.detail.variants[0].available,
    });
  }
  pdpCore();
});

// Used with snippets/collectionBannerGrid.liquid and
// sections/section-banner-new.liquid. These do not mount correctly and look
// broken when the images are lazy loaded, so we're using IO to determine
// when to mount.
const initGlideCarousels = () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!target.matches(".mounted") && isIntersecting) {
        target.classList.add("mounted");
        initGlideCarousel(target);
      }
    });
  });

  document.querySelectorAll(".glide").forEach((carousel) => {
    observer.observe(carousel);
  });
};
const initGlideCarousel = (el) => {
  const id = el.id;

  if (!id) {
    return;
  }

  const glide = new Glide(`#${id}`, {
    type: "slider",
    rewind: false,
    startAt: 0,
    perView: 4,
    gap: 20,
    dragThreshold: false,
    direction: "ltr",
    breakpoints: {
      768: {
        peek: {
          before: 25,
          after: 0,
        },
        perView: 1.3,
        gap: 10,
        dragThreshold: true,
        rewind: true,
      },
    },
  });

  glide.on("mount.after", function () {
    setTimeout(() => {
      let bannerSlider = document.querySelector(`.banner-${id}`);
      bannerSlider.style.opacity = "1";
    }, 500);
  });

  glide.mount();
};

initGlideCarousels();
